<template>
    <div class="pop-up-main">
        <div class="paln-box">
            <div class="movableItem" :style="{ width: width, height: height }" @mousewheel="rollImg($event)"
                @DOMMouseScroll="rollImg($event)" @mousedown="drag($event, 1)" ref="bigImage">
                <!-- 图片不可选中 或不可拖拽到新标签打开-->
                <img :src="imgUrl" oncontextmenu="return false;" onselectstart="return false;" draggable="false" alt />
                <div :class="selectOrderNo == item.OrderNo?'marker-select':'marker'" @mousedown="dragSign($event, key)" v-for="(item, key) in hotPoints" :key="key"
                    :style="{ top: ($options.filters.ySplitText(item.XCoor)* (newWidth / imgWidth) - 3) + 'px', 
                    left: ($options.filters.xSplitText(item.XCoor)* (newWidth / imgWidth) - 3) + 'px', 
                    width:  (Math.abs(($options.filters.xSplitText(item.XCoor) - $options.filters.xSplitText(item.YCoor)))* (newWidth / imgWidth) + 6) + 'px',
                    height: (Math.abs(($options.filters.ySplitText(item.XCoor) - $options.filters.ySplitText(item.YCoor)))* (newWidth / imgWidth) + 6) + 'px'}"
                    @click="findOeInTB(item)"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        imgUrl: {},
        hotPoints: []
    },

    data() {
        return {
            // 定时器
            timer: '',
            // 图片加载失败
            imgOnerror: false,
            // 图片显示默认大小
            width: '',
            height: '',
            imgWidth: '',
            imgHeight: '',

            // 可缩小倍数,为空则可无限缩小
            minification: 1,
            // 可放大倍数 为空则可无限放大
            magnification: 3,
            bigMaxWidth: 1600,
            bigMaxHeight: 800,

            ms: 20, //函数节流 ms 时间触发一次
            lastClick: Date.now() - 20,
            selectOrderNo: '',
            newWidth: 380
        };
    },
    filters: {
        xSplitText(x) {
            if (~x.indexOf(',')) {
                return x.split(',')[0];
            } else {
                return x;
            }
        },
        ySplitText(x) {
            if (~x.indexOf(',')) {
                return x.split(',')[1];
            } else {
                return x;
            }
        }
    },
    methods: {
        // 获取图片大小
        // ,objWidth,objHeight
        getImgInfo(imgUrl, MaxWidth, MaxHeight, StrWidth, StrHeight, Array = false, arr, num = 0) {
            // console.log("objWidthName", this[StrWidth], this[StrHeight]);
            var img = new Image();

            img.src = imgUrl;
            // const vm = this;
            let that = this;
            img.onerror = () => {
                that.imgOnerror = true;
                this.timer = setTimeout(() => {
                    if (num <= 5) {
                        that.getImgInfo(imgUrl, MaxWidth, MaxHeight, StrWidth, StrHeight, Array, arr, num + 1);
                    }
                    clearInterval(this.timer);
                }, 2000);
            };
            img.onload = function(e) {
                that.imgHeight = img.height;
                that.imgWidth = img.width;
                that.width = '380px';
                let ratio2 = img.width / img.height;
                that.height = 380 / ratio2 + 'px';
            };
        },
        // 缩放
        rollImg() {
            var oImg = this.$refs.bigImage;
            var that = this;
            function fnWheel(obj, fncc) {
                obj.onmousewheel = fn;
                if (obj.addEventListener) {
                    obj.addEventListener('DOMMouseScroll', fn, false);
                }
                function fn(ev) {
                    if (Date.now() - that.lastClick >= that.ms) {
                        that.lastClick = Date.now();
                        var oEvent = ev || window.event;
                        var down = true;
                        if (oEvent.detail) {
                            down = oEvent.detail > 0;
                        } else {
                            down = oEvent.wheelDelta < 0;
                        }
                        if (fncc) {
                            fncc.call(this, down, oEvent);
                        }
                        if (oEvent.preventDefault) {
                            oEvent.preventDefault();
                        }
                        return false;
                    }
                }
            }
            fnWheel(oImg, function(down, oEvent) {
                var oldWidth = this.offsetWidth;
                var oldHeight = this.offsetHeight;
                var oldLeft = this.offsetLeft;
                var oldTop = this.offsetTop;
                if (!oEvent.path) {
                    oEvent.path = that.eventPath(oEvent);
                }
                var parent = oEvent.path[2];
                // 获取父元素距离页面可视区域的位置
                var parentLeft = parent.getBoundingClientRect().left;
                var parentTop = parent.getBoundingClientRect().top;
                // 比例 = （点击位置距离可视窗口位置 - 父元素距离可视窗口位置 - 相对定位的left）/ 本身宽度
                var scaleX = (oEvent.clientX - parentLeft - oldLeft) / oldWidth; //比例
                var scaleY = (oEvent.clientY - parentTop - oldTop) / oldHeight;

                let nowWidth = this.style.width.split('p')[0];
                let initWidth = that.width.split('p')[0];
                let initHeight = that.height.split('p')[0];

                let miniFlag = true;
                let magniFlag = true;
                if (that.minification) {
                    // 限制缩小范围
                    if (nowWidth <= parseInt(initWidth / that.minification)) {
                        miniFlag = false;
                        this.style.width = parseInt(initWidth / that.minification) + 'px';
                        this.style.height = parseInt(initHeight / that.minification) + 'px';
                    }
                    if (that.magnification) {
                        // 限制放大范围
                        if (nowWidth >= parseInt(initWidth * that.magnification)) {
                            magniFlag = false;
                            this.style.width = parseInt(initWidth * that.magnification) + 'px';
                            this.style.height = parseInt(initHeight * that.magnification) + 'px';
                        }
                    }
                }

                if (down && miniFlag) {
                    this.style.width = parseInt(this.offsetWidth * 0.9) + 'px';
                    this.style.height = parseInt(this.offsetHeight * 0.9) + 'px';
                } else if (!down && magniFlag) {
                    this.style.width = parseInt(this.offsetWidth * 1.1) + 'px';
                    this.style.height = parseInt(this.offsetHeight * 1.1) + 'px';
                }
                var newWidth = this.offsetWidth;
                var newHeight = this.offsetHeight;

                // 新的相对位置left = 原先的相对位置left - 比例 *（本身新的宽度-旧的宽度）
                this.style.left = Math.round(this.offsetLeft - scaleX * (newWidth - oldWidth)) + 'px';
                this.style.top = Math.round(this.offsetTop - scaleY * (newHeight - oldHeight)) + 'px';
                
                that.newWidth = newWidth;
            });
        },
        // },
        //拖拽
        drag(ev) {
            let that = this;
            var nn6 = document.getElementById && !document.all;
            var isdrag = false;
            var y, x;
            var nTY, nTX;
            var oDragObj;
            function moveMouse(e) {
                if (isdrag) {
                    oDragObj.style.top = (nn6 ? nTY + e.clientY - y : nTY + event.clientY - y) + 'px';
                    oDragObj.style.left = (nn6 ? nTX + e.clientX - x : nTX + event.clientX - x) + 'px';
                    return false;
                }
            }
            function initDrag(e) {
                var oDragHandle = nn6 ? e.target : event.srcElement;
                var topElement = 'HTML';
                while (oDragHandle.tagName != topElement && oDragHandle.className != 'movableItem') {
                    oDragHandle = nn6 ? oDragHandle.parentNode : oDragHandle.parentElement;
                }
                if (oDragHandle.className == 'movableItem') {
                    if (!e.path) {
                        e.path = that.eventPath(e);
                    }
                    isdrag = true;
                    oDragObj = oDragHandle;
                    // 父元素宽高
                    let width = e.path[2].offsetWidth;
                    let height = e.path[2].offsetHeight;
                    // 这里判断第一次获取不到style 样式 默认为 居中50%
                    if (oDragObj.style.top == '') {
                        nTY = parseInt((50 * height) / 100 + 0);
                        nTX = parseInt((50 * width) / 100 + 0);
                    } else {
                        nTY = parseInt(oDragObj.style.top + 0);
                        nTX = parseInt(oDragObj.style.left + 0);
                    }
                    y = nn6 ? e.clientY : event.clientY;
                    x = nn6 ? e.clientX : event.clientX;
                    oDragObj.style.cursor = 'move';
                    document.onmousemove = moveMouse;
                    return false;
                }
            }
            document.onmousemove = initDrag;

            document.onmouseup = function(e) {
                isdrag = false;
                document.onmousemove = null;
                document.onmouseup = null;
                var oDragHandle = nn6 ? e.target : event.srcElement;
                var topElement = 'HTML';
                while (oDragHandle.tagName != topElement && oDragHandle.className != 'movableItem') {
                    oDragHandle = nn6 ? oDragHandle.parentNode : oDragHandle.parentElement;
                }
                if (oDragHandle.className == 'movableItem') {
                    oDragObj = oDragHandle;
                    oDragObj.style.cursor = 'Default';
                }
            };
            ev = event || window.event;

            // 取消事件冒泡行为
            // window.event ? (window.event.cancelBubble = true) : ev.stopPropagation();
        },
        // 拖拽标记
        dragSign(ev, key) {
            var nn6 = document.getElementById && !document.all;
            var isdrag = false;
            var y, x;
            var nTY, nTX;
            var oDragObj;
            let that = this;
            function moveMouse(e) {
                if (isdrag) {
                    if (!e.path) {
                        e.path = that.eventPath(e);
                    }

                    let widthItem = e.path[1].style.width.split('p');
                    let heightItem = e.path[1].style.height.split('p');
                    let width = widthItem[0];
                    let height = heightItem[0];

                    let top = ((nn6 ? (nTY / 100) * height + e.clientY - y : (nTY / 100) * height + event.clientY - y) / height) * 100;
                    let left = ((nn6 ? (nTX / 100) * width + e.clientX - x : (nTX / 100) * width + event.clientX - x) / width) * 100;

                    console.log(top);
                    if (top >= 0 && top <= 100) {
                        that.equipment[key].top = top;
                    }
                    if (left >= 0 && left <= 100) {
                        that.equipment[key].left = left;
                    }

                    return false;
                }
            }
            function initDrag(e) {
                var oDragHandle = nn6 ? e.target : event.srcElement;
                var topElement = 'HTML';
                while (oDragHandle.tagName != topElement && oDragHandle.className.indexOf('equipment') == -1) {
                    oDragHandle = nn6 ? oDragHandle.parentNode : oDragHandle.parentElement;
                }
                if (oDragHandle.className.indexOf('equipment') != -1) {
                    isdrag = true;
                    oDragObj = oDragHandle;

                    if (!e.path) {
                        e.path = that.eventPath(e);
                    }

                    // 父元素宽高
                    let width = e.path[1].offsetWidth;
                    let height = e.path[1].offsetHeight;
                    // 这里判断第一次获取不到style 样式 默认为 居中50%
                    if (oDragObj.style.top == '') {
                        nTY = parseInt((50 * height) / 100 + 0);
                        nTX = parseInt((50 * width) / 100 + 0);
                    } else if (oDragObj.style.top.indexOf('%') != -1) {
                        nTY = oDragObj.style.top.split('%')[0];
                        nTX = oDragObj.style.left.split('%')[0];
                    } else {
                        nTY = parseInt(oDragObj.style.top + 0);
                        nTX = parseInt(oDragObj.style.left + 0);
                    }
                    y = nn6 ? e.clientY : event.clientY;
                    x = nn6 ? e.clientX : event.clientX;

                    oDragObj.style.cursor = 'move';
                    document.onmousemove = moveMouse;
                    return false;
                }
            }

            // document.onmousedown = initDrag;
            document.onmousemove = initDrag;

            document.onmouseup = function(e) {
                isdrag = false;
                document.onmousemove = null;
                document.onmouseup = null;
                var oDragHandle = nn6 ? e.target : event.srcElement;
                var topElement = 'HTML';
                while (oDragHandle.tagName != topElement && oDragHandle.className != 'equipment') {
                    oDragHandle = nn6 ? oDragHandle.parentNode : oDragHandle.parentElement;
                }
                if (oDragHandle.className == 'equipment') {
                    oDragObj = oDragHandle;
                    oDragObj.style.cursor = 'Default';
                }
            };

            ev = event || window.event;

            // 取消事件冒泡行为
            window.event ? (window.event.cancelBubble = true) : ev.stopPropagation();
        },
        eventPath(evt) {
            const path = (evt.composedPath && evt.composedPath()) || evt.path,
                target = evt.target;

            if (path != null) {
                return path.indexOf(window) < 0 ? path.concat(window) : path;
            }

            if (target === window) {
                return [window];
            }

            function getParents(node, memo) {
                memo = memo || [];
                const parentNode = node.parentNode;

                if (!parentNode) {
                    return memo;
                } else {
                    return getParents(parentNode, memo.concat(parentNode));
                }
            }

            return [target].concat(getParents(target), window);
        },
        findOeInTB(item) {
            if (this.selectOrderNo == item.OrderNo) {
                this.selectOrderNo = '';
            } else {
                this.selectOrderNo = item.OrderNo;
            }
            this.$emit('findOeInTB', item);
        }
    },
    destroyed() {
        clearInterval(this.timer);
    },
    created() {
        this.getImgInfo(this.imgUrl, this.bigMaxWidth, this.bigMaxHeight, 'width', 'height');
    }
};
</script>
<style lang="less" scoped>
.pop-up-main {
    width: 100%;
    height: 100%;
    background: #ccc;

    .paln-box {
        width: 100%;
        height: 100%;
        position: relative;

        .movableItem {
            position: absolute;
            top: 0;
            left: 0;
            transform: translate(0, 0);

            img {
                z-index: 1;
                width: 100%;
                height: 100%;
            }

            .marker {
                position: absolute;
                top: 0;
                left: 0;
                transform: translate(0, 0);
                border-radius: 10%;
                background-color: rgba(250, 177, 177, 0.5);
                line-height: 20px;
            }

            .marker:hover {
                background-color: rgba(197, 41, 41, 0.5);
            }

            .marker-select {
                position: absolute;
                border-radius: 10%;
                background-color: rgba(16, 243, 16, 0.5);
                text-align: center;
                line-height: 20px;
            }
        }

        .shuaxin {
            position: absolute;
            z-index: 2;
            font-size: 40px;
            top: 20px;
            left: 20px;
            cursor: pointer;

            &:hover {
                color: yellowgreen;
            }
        }

        .equipment {
            color: white;
        }

        &/deep/.el-button {
            z-index: 2;
            position: absolute;
            bottom: 60px;
            right: 20px;
            width: 60px;
            height: 35px;

            span {
                display: inline-block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            i {
                display: inline-block;
                position: absolute;
                top: 50%;
                left: 25%;
                transform: translate(-50%, -50%);
            }
        }
    }
}
</style>
